import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Dashboard from "./components/Dashboard";
import Login from "./components/Login";
import ForgotPassword from "./components/ForgotPassword";
import AuthAction from "./components/AuthAction";
import PrivateRoute from "./components/PrivateRoute";
import PublicRoute from "./components/PublicRoute";
import Home from "./pages/Home";
import Clientes from "./pages/Clientes";
import ClientesArchivados from "./pages/ClientesArchivados";
import ClienteDetails from "./pages/ClienteDetails";
import LinkDetails from "./pages/LinkDetails";
import ExploradorArchivos from "./pages/ExploradorArchivos";
//import Criterios from "./pages/Criterios";
import Configuracion from "./pages/Configuracion";
import BillingSuccess from "./pages/billing/BillingSuccess";
import BillingCancel from "./pages/billing/BillingCancel";
import Support from "./pages/Support";
import Changelog from "./pages/Changelog";
import ExpedienteUpload from "./pages/ExpedienteUpload";
//import ChatSubscription from "./components/ChatSubscription";
import Contratos from "./pages/Contratos";
import Fianzas from "./pages/Fianzas";
import Reportes from "./pages/Reportes";
import Comisiones from "./pages/Comisiones";
import Pulso from "./pages/Pulso";
import Pendientes from "./pages/Pendientes";
import OrdenesTrabajo from "./pages/OrdenesTrabajo";
import Bitacora from "./pages/Bitacora";
import Convenios from "./pages/Convenios";
import ConvenioDetails from "./pages/ConvenioDetails";
import ClientPortalHome from "./pages/portal/ClientPortalHome";
import ClientPortalBandeja from "./pages/portal/ClientPortalBandeja";
import ClientPortalCliente from "./pages/portal/ClientPortalCliente";
import ClientPortalContratos from "./pages/portal/ClientPortalContratos";
import ClientPortalFianzas from "./pages/portal/ClientPortalFianzas";
import ClientPortalReportes from "./pages/portal/ClientPortalReportes";
import ClientPortalExpedientes from "./pages/portal/ClientPortalExpedientes";
import ClientPortalAfianzadoras from "./pages/portal/ClientPortalAfianzadoras";
import ClientPortalConvenios from "./pages/portal/ClientPortalConvenios";
import ClientPortalConvenio from "./pages/portal/ClientPortalConvenio";
import { UserProvider } from "./components/UserContext";
import EnvironmentBanner from "./components/EnvironmentBanner";
import UpdateBanner from "./components/UpdateBanner";
import { EnvironmentProvider } from "./contexts/EnvironmentContext";
import { DataProvider } from "./contexts/DataContext";
import { PortalViewProvider } from "./contexts/PortalViewContext";
import { PendienteContextoProvider } from "./contexts/PendienteContexto";
import { useUser } from "./components/UserContext";

const RoleAwareRedirect = () => {
  const { userData, loading } = useUser();
  if (loading) return null;
  if (userData?.rol === "client") {
    return <Navigate to="/app/portal" replace />;
  }
  return <Navigate to="/app/inicio" replace />;
};

function App() {
  return (
    <EnvironmentProvider>
      <Router>
        <EnvironmentBanner />
        <UpdateBanner />
        <Routes>
        {/* Public Routes */}
        <Route
          path="/login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
        <Route
          path="/forgot-password"
          element={
            <PublicRoute>
              <ForgotPassword />
            </PublicRoute>
          }
        />
        <Route
          path="/auth/action"
          element={
            <PublicRoute>
              <AuthAction />
            </PublicRoute>
          }
        />
        <Route path="/expediente/:linkId" element={<ExpedienteUpload />} />

        {/* Private Routes */}
        <Route
          path="/app"
          element={
            <PrivateRoute>
              <UserProvider>
                <DataProvider>
                  <PortalViewProvider>
                    <PendienteContextoProvider>
                    <Dashboard />
                  </PendienteContextoProvider>
                  </PortalViewProvider>
                </DataProvider>
              </UserProvider>
            </PrivateRoute>
          }
        >
          <Route path="inicio" element={<Home />} />
          <Route path="pulso" element={<Pulso />} />
          <Route path="pendientes" element={<Pendientes />} />
          <Route path="ordenes" element={<OrdenesTrabajo />} />
          {/* <Route path="chat-subscripcion" element={<ChatSubscription />} /> */}
          <Route path="clientes" element={<Clientes />} />
          <Route path="clientes/archivados" element={<ClientesArchivados />} />
          <Route path="clientes/:clientId" element={<ClienteDetails />} />
          {/* Legacy combined route now points to contratos */}
          <Route path="contratos-fianzas" element={<Contratos />} />
          <Route path="contratos" element={<Contratos />} />
          <Route path="fianzas" element={<Fianzas />} />
          <Route path="convenios" element={<Convenios />} />
          <Route path="convenios/:convenioId" element={<ConvenioDetails />} />
          <Route path="reportes" element={<Reportes />} />
          <Route path="comisiones" element={<Comisiones />} />
          <Route path="bitacora" element={<Bitacora />} />
          <Route path="expedientes/:linkId" element={<LinkDetails />} />
          <Route path="explorador-archivos" element={<ExploradorArchivos />} />
          {/* <Route path="criterios" element={<Criterios />} /> */}
          <Route path="portal" element={<ClientPortalHome />} />
          <Route path="portal/bandeja" element={<ClientPortalBandeja />} />
          <Route path="portal/cliente/:clientId" element={<ClientPortalCliente />} />
          <Route path="portal/expedientes" element={<ClientPortalExpedientes />} />
          <Route path="portal/contratos" element={<ClientPortalContratos />} />
          <Route path="portal/fianzas" element={<ClientPortalFianzas />} />
          <Route path="portal/reportes" element={<ClientPortalReportes />} />
          <Route path="portal/afianzadoras" element={<ClientPortalAfianzadoras />} />
          <Route path="portal/convenios" element={<ClientPortalConvenios />} />
          <Route path="portal/convenios/:convenioId" element={<ClientPortalConvenio />} />
          <Route path="config" element={<Configuracion />} />
          <Route path="billing/success" element={<BillingSuccess />} />
          <Route path="billing/cancel" element={<BillingCancel />} />
          <Route path="support" element={<Support />} />
          <Route path="changelog" element={<Changelog />} />
          <Route index element={<RoleAwareRedirect />} />
        </Route>

        {/* Fallback Route */}
        <Route path="*" element={<Navigate to="/app/inicio" />} />
      </Routes>
    </Router>
    </EnvironmentProvider>
  );
}

export default App;
